

<script>
import { mapGetters } from 'vuex';

export default {
  name: "EnableQuote",

  methods:{
    enableQuote() {
      const params = new URLSearchParams(window.location.search);
      params.set("md", "quote");
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );

      this.$emit("actifQuote");

    }
  },

  props : {
    quoteIsActif:{
          type:Boolean,
          default: false,
    },
  },

  
    computed:{
        ...mapGetters('cart', ['cart', 'isLoadingCart', 'submitOrderInProgress', 'orderSubmited', 'orderFailed']),

    },



};
</script>


<template>
  <div>
        
    <div  v-if="submitOrderInProgress" 
      class="enable-quote-bar d-flex align-items-center shadow-lg p-3 px-3 justify-content-between" >
      <div class="d-flex align-items-center w-100 justify-content-center">
        <span style="font-size: 40px; letter-spacing: 0.3rem;" class="text-primary">
          <span v-for="n in dots" :key="n" class="dot">.</span>
        </span>
      </div>
    </div>

    <div v-else-if="orderSubmited" class="enable-quote-bar d-flex align-items-center shadow-lg p-3 px-3 justify-content-center text-primary" >
      <div class="d-flex align-items-center">
        <img
          src="@/assets/icons/checked.gif"
          height="70"
          class="mr-2"
          alt="Commande envoyée"
          style="vertical-align: middle;"/>

        <span
          class="order-submitted-text text-uppercase fw-bold"
          style="font-size: 18px; letter-spacing: 0.15rem;"
        >
          {{ $t('menuOrder.cart.quoteSubmitted') }}
        </span>
      </div>
    </div>

    <div v-else-if="orderFailed" class="enable-quote-bar d-flex align-items-center shadow-lg p-3 px-3 justify-content-center text-danger" >
      <div class="d-flex align-items-center">
        <img
          src="@/assets/icons/error2.gif"
          height="50"
          class="mr-2"
          alt="Échec commande"
          style="vertical-align: middle;"/>
        <span
          class="order-submitted-text text-uppercase fw-bold"
          style="font-size: 18px; letter-spacing: 0.15rem;"
        >
          {{ $t('menuOrder.cart.quoteFailed') }}
        </span>
      </div>
    </div>

    <div v-else-if="quoteIsActif" class="enable-quote-bar d-flex align-items-center shadow-lg p-3 px-3" style="justify-content: center;">
      <b-button @click="$emit('expand')" variant="light" class="btn-pill text-white font-weight-bold font-size-16 enable-quote-btn position-relative" >
        {{ $t('menuOrder.cart.button.quoteCart') }}

        <b-badge
          v-if="cart && cart.lines && cart.lines.draft && cart.lines.draft.count "
          variant="danger"
          class="position-absolute rounded-circle font-weight-bold"
          style="top: -5px; right: -8px; font-size: 10px; padding: 0.3rem 0.4rem;"
        >
          {{ cart.lines.draft.count }}
        </b-badge>
      </b-button>
    </div>

      <div v-else class="enable-quote-bar d-flex align-items-center shadow-lg p-3 px-3" style="justify-content: center;">
      <b-button @click="enableQuote" variant="light" class="btn-pill text-white font-weight-bold font-size-16 enable-quote-btn position-relative" >
        {{ $t('menuOrder.cart.button.freeQuote') }}
      </b-button>
    </div>

    </div>
</template>


<style scoped>
.enable-quote-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 0.75rem 1rem;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2) !important;
  z-index: 1000;
  transform: translateZ(0); 
  height: 77px;
}

.enable-quote-btn {
  border-radius: 25px;
  padding: 0.6rem 1.9rem;
  background: linear-gradient(90deg, #28a745, #218838);
  transition: all 0.2s;
  letter-spacing: 0.1rem;
}

</style>